var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500244 2C0.500244 1.44772 0.947959 1 1.50024 1H10.5002C11.0525 1 11.5002 1.44772 11.5002 2V11C11.5002 11.5523 11.0525 12 10.5002 12H1.50024C0.947959 12 0.500244 11.5523 0.500244 11V2Z",
    stroke: "currentcolor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3501_1864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: "1em",
    height: "1em"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 2C0.000244141 1.17157 0.671817 0.5 1.50024 0.5H10.5002C11.3287 0.5 12.0002 1.17157 12.0002 2V11C12.0002 11.8284 11.3287 12.5 10.5002 12.5H1.50024C0.671817 12.5 0.000244141 11.8284 0.000244141 11V2Z",
    fill: "currentcolor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3501_1864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.251953 7.24306L2.47791 5.0376C2.78872 4.72965 3.29264 4.72965 3.60345 5.0376L10.877 12.2442",
    stroke: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19385 7.81287L7.21408 6.79264C7.99513 6.01159 9.26146 6.01159 10.0425 6.79264L11.7753 8.52539",
    stroke: "currentcolor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpaper);
export default __webpack_public_path__ + "static/media/wallpaper.4fd58fa0e914326b574f31b692c4944f.svg";
export { ForwardRef as ReactComponent };